import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import ProductCategory1 from '../take-away-bags/Product-category-section/product-category1';
import ProductCategory2 from '../take-away-bags/Product-category-section/product-category2';
// import ProductCategory3 from '../take-away-bags/Product-category-section/product-category3';
// import ProductCategory4 from '../take-away-bags/Product-category-section/product-category4';
// import ProductCategory5 from '../take-away-bags/Product-category-section/product-category5';
// import ProductCategory6 from '../take-away-bags/Product-category-section/product-category6'
const TakeAwayBags = () => {
  const navigate=useNavigate()
  return (
    <>
    <div className="container-fluid bags-container d-flex align-items-center">
      <div className="row justify-content-center w-100">
        <div className="col-12 col-lg-10">
          <div className="card-banner">
            <div className="row g-0">
              {/* Left side with single product image */}
              <div className="col-md-6  d-flex align-items-center justify-content-center p-5" >
                <img
                  src="/assets/products-with-logo/paper-bags/take-away-bags.jpg"
                  className="img-fluid"
                  alt="take-away"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
              
              {/* Right side content */}
              <div className="col-md-6 d-flex align-items-center" >
                <div className="p-4 p-lg-5 w-100">
                  <small className="text-black text-uppercase letter-spacing-1 mb-2 d-block">
                  Chic, sturdy, functional
                  </small>
                  
                  <h2 className="main-heading display-5 fw-bold text-dark mb-4">
                   Take Away Bags
                  </h2>
                  
                  <p className="product-each-desc text-black mb-4 lead">
                   {/* Takeaway bags are durable and spacious, designed for secure and convenient packaging, offering grease-resistant and eco-friendly solutions for food delivery and takeout orders.             */}

                   Ensure your customers enjoy their meals on the go with our convenient and reliable restaurant takeaway bags. Designed with functionality and durability in mind, these bags are perfect for safely transporting food from your restaurant to customers' homes or offices. Our takeaway bags are leak-proof and grease-resistant, available in a variety of sizes, and environmentally friendly. We offer these bags in custom sizes according to your specific requirements, allowing you to provide the perfect packaging solution for all your takeaway needs.
                        </p>                  
                  <div className="text-center mb-4">
                    <button 
                      className="btn btn-dark btn-sm rounded-pill text-uppercase mx-auto" 
                      style={{ 
                        width: '100px',
                        fontSize: '0.6rem',
                        padding: '10px 2px',
                        lineHeight: '1.2',
                        display: 'block'
                      }} onClick={()=>{navigate('/contact')}}>
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProductCategory1/>
    {/* <ProductCategory6/> */}
    <ProductCategory2/>
    {/* <ProductCategory3/>
     <ProductCategory4/> */}
    {/* <ProductCategory5/> */}
</>
  );
};

export default TakeAwayBags;